export default __webpack_public_path__ + "static/media/Golden-Snitch-Rigged-00.12b3787f.jpg";